// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1qFEM","header":"MergedInvoice_header__119b_"};